import { SearchField as SearchFieldDesktop } from "./search-field";

export { SearchFieldType, SearchFieldVariant } from "./types";

export const SearchField = SearchFieldDesktop;
